import { render, staticRenderFns } from "./PieChartAccessIntent.vue?vue&type=template&id=50b6407c"
import script from "./PieChartAccessIntent.vue?vue&type=script&lang=js"
export * from "./PieChartAccessIntent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports